import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Leading the Evolution of React Native App Development in Dubai
            </h2>
            <p>
              As one of the leading cross-platform app development companies in
              the Dubai region, TekRevol is at the front of React Native mobile
              app development company intended to nurture your progress and
              flexibility in a swiftly developing digital world.
            </p>
            <p>
              Using pioneering technology, we create React Native apps that not
              only deliver a competitive edge but also take customer engagement
              to new heights.
            </p>
            <p>
              Our skillful team collaborates closely with you to clutch your
              unique business needs and goals. We modify our React Native app
              development procedures to provide scalable solutions that progress
              effortlessly with the development of your business. You can count
              on TekRevol as your trusted partner in the React Native app
              development company in UAE, fueling your passion with the right
              digital tools needed to stay ahead in all evolving markets of Gulf
              Cooperation Council countries.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <StaticImage
                src="../../images/location_new/fold11/leading_react_native_dubai.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={775}
                height={670}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
